import {createSlice, PayloadAction}  from '@reduxjs/toolkit';
import { PosState, UpdateCurrentPosAgencyAction } from '../pos.types';


const initialState: PosState  = {
    currentAgency:null
}

export const posSlice = createSlice({
    name:'pos',
    initialState,
    reducers:{
        setCurrentPosAgency:(state, action: PayloadAction<UpdateCurrentPosAgencyAction>) => {
            state.currentAgency = action.payload.currentAgency
        }
    }
});

export const {setCurrentPosAgency} = posSlice.actions;
export const posReducer = posSlice.reducer;